<template>
  <el-dialog :title="title" :visible.sync="show" :center="true" width="640px" :append-to-body="true" :close-on-click-modal="false">
    <div class="file-box" v-loading="loading" :element-loading-text="text">
      <el-upload
              ref="upload"
              action=""
              accept=".txt,.png,.jpg,.bmp,.gif,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.zip,.7z,.rar"
              :auto-upload="false"
              :multiple="true"
              :limit="limit"
              :on-exceed="handleExceed"
              :on-change="onChange">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="upload" :disabled="fileList.length > 0 ? false : true">上传文件</el-button>
        <span style="color: #f60; font-size: 14px; padding-left: 8px;">(当前限制选择 {{ limit }} 个文件)</span>
      </el-upload>

      <Upload ref="uploader" @complete="finishUpload" />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeFn" size="small">关闭窗口</el-button>
      <el-button :disabled="endFile.length > 0 ?  false : true" @click="closeFn" size="small" type="primary">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 公共上传类
import Upload from "@/components/management/file/Upload";

export default {
  name: "AddFile",
  props: [],
  components: {
    Upload
  },
  data() {
    return {
      limit: 1,
      baseUrl: process.env.BASE_URL,
      title: "",
      show: false,
      loading: false,
      text: "",
      fileList: [],
      endFile: [],
      uploadFiles: [] // 每次要上传的文件
    };
  },
  computed: {},
  created() {},
  mounted() { },
  destroyed() {},
  methods: {
    finishUpload(ids){
      ids.forEach( e => {
        if ( e.type === "error") {
          this.$refs.upload.uploadFiles.splice(this.$refs.upload.uploadFiles.findIndex(item => item.uid === e.uid), 1);
        } else {
          this.endFile.push(e);
        }
      })

      setTimeout( () => {
        this.loading = false;
        this.text = "";
      }, 2000 )
    },
    // 显示弹框
    showBox (data) {
      this.show = true;
      this.endFile = [];
      this.$nextTick( () => {
        this.title = data.title;
        this.limit = data.limit;
        this.$refs.upload.clearFiles();
        this.$refs.uploader.clearFileList();
      })
    },
    // 上传
    upload() {
      this.loading = true;

      this.$nextTick( () => {
        this.text = "正在处理上传文件，请勿关闭窗口……";
        this.uploadFiles = this.$refs.upload.uploadFiles;

        // 处理上一次上传过的文件
        this.endFile.forEach( e => {
          this.uploadFiles.splice(this.uploadFiles.findIndex(item => item.uid === e.uid), 1);
        })

        this.$refs.uploader.addFiles(this.uploadFiles.map(val => val.raw))
      })
      
    },
    //获取文件id
    getFileId() {},
    submitFn () {},
    onChange(file, fileList) {
      this.fileList = fileList;
    },
    handleExceed() {
      this.$message.warning("当前限制选择 " + this.limit + " 个文件");
    },
    // 关闭
    closeFn () {
      this.show = false;
      this.fileList = [];
      this.$refs.uploader.show = false;
      this.$parent.initPage()
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
  .file-box {
    width: 100%;
    height: 100%;
  }

  .el-upload-list {
      height: 300px;
    }
    
  .dialog-footer {
    text-align: center;
  }
</style>
